import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { DiarySection } from './components/DiarySection';
import { ProductReveal } from './components/ProductReveal';
import { StoryBridge } from './components/StoryBridge';
import { ProductSection } from './components/ProductSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { TrustBar } from './components/TrustBar';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),
    event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='
    +i+dl;f.parentNode.insertBefore(j,f);})(window,document,
    'script','dataLayer','GTM-KZBZMFT');`;
    document.head.appendChild(script);
  }, []);
  return <div className="min-h-screen bg-stone-50 flex flex-col" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <DiarySection data-id="element-4" />
        <ProductReveal data-id="element-5" />
        <StoryBridge data-id="element-6" />
        <ProductSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <TrustBar data-id="element-9" />
        <CTASection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}